import styled from 'styled-components';

export const StyledPrintPdfDropdown = styled.div`
    position: relative;
    cursor: pointer;
    
    .dropdown {
        border-radius: 10px;
        box-shadow: -10px 48.5967px 140px rgba(126, 123, 160, 0.2);
        position: absolute;
        top: 40px;
        left: 0;
        z-index: 99;
        direction: ltr;
    }
    
    .icons-section {
        width: 200px;
        background: linear-gradient(190.57deg, #FFFFFF 19.25%, #F8F8FF 54.39%, #FFFFFF 90.02%);
        height: 40px;
        padding: 10px;
        cursor: pointer;
        display: flex;
        gap: 17px;
        align-items: center;
        font-weight: 700;
        font-size: 14px;
        color: rgba(55, 54, 71, 0.7);

        :hover {
            background: #F5F4FC;
            color: #373647;
        }

        img {
            height: 18px;
        }
    }

    // styles for iframe pdf generation
    .hidden-box {
        position: absolute;
        visibility: hidden;
        float: left;
        width: 1px;
        height: 1px;
        overflow: hidden;
      }
`